import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import toast from 'react-hot-toast';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [busy, setBusy]   = useState(false);

  const handleSub = async e => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try { const r = await api.post('/newsletter', { email }); toast.success(r.message || 'Subscribed!'); setEmail(''); }
    catch (err) { toast.error(err.message); }
    finally { setBusy(false); }
  };

  const footLink = { color: 'rgba(255,255,255,0.5)', fontSize: 13, textDecoration: 'none', display: 'block', marginBottom: 9 };

  return (
    <footer style={{ fontFamily: "'Jost',sans-serif" }}>
      {/* Newsletter */}
      <div style={{ background: 'linear-gradient(135deg,#2b1745,#7c3aed)', padding: '52px 0' }}>
        <div className="container">
          <div className="footer-nl" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 32, flexWrap: 'wrap' }}>
            <div>
              <div style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#fdba74', marginBottom: 6 }}>Join Our Community</div>
              <h3 style={{ fontFamily: "'Playfair Display',serif", fontSize: 'clamp(1.4rem,2.5vw,2rem)', color: '#fff', fontStyle: 'italic', marginBottom: 6 }}>Stories in Every Thread</h3>
              <p style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13 }}>Exclusive collections, weaving stories & artisan spotlights.</p>
            </div>
            <form onSubmit={handleSub} style={{ display: 'flex', gap: 10, flex: 1, maxWidth: 440, minWidth: 240 }}>
              <input type="email" value={email} onChange={e => setEmail(e.target.value)} required placeholder="Your email address" style={{ flex: 1, padding: '12px 16px', border: 'none', background: 'rgba(255,255,255,0.14)', color: '#fff', fontSize: 14, outline: 'none' }} />
              <button type="submit" className="btn btn-gold" disabled={busy} style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>{busy ? '...' : 'Subscribe'}</button>
            </form>
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div style={{ background: '#181214', padding: '60px 0 0' }}>
        <div className="container">
          <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1.2fr 1.5fr', gap: 40, marginBottom: 48 }}>
            {/* Brand */}
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                <div style={{ width: 46, height: 46, borderRadius: 16, background: 'linear-gradient(135deg,#c9a46a,#e7c897)', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: "'Playfair Display',serif", fontSize: 20, fontWeight: 700 }}>A</div>
                <div>
                  <div style={{ fontFamily: "'Playfair Display',serif", fontSize: 20, color: '#fff', lineHeight: 1 }}>Demo Shop</div>
                  <div style={{ fontSize: 9, letterSpacing: '4px', color: '#fdba74', textTransform: 'uppercase' }}>Demo Preview</div>
                </div>
              </div>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, lineHeight: 1.8, marginBottom: 18 }}>A premium demo storefront designed for preview, presentation, and a polished boutique shopping experience.</p>
              <div style={{ marginBottom: 18 }}>
                {['💳 Cards', '📱 UPI', '🏦 Net Banking', '📦 COD'].map(p => <span key={p} style={{ display: 'inline-block', background: 'rgba(255,255,255,0.08)', color: 'rgba(255,255,255,0.6)', padding: '3px 9px', fontSize: 10, border: '1px solid rgba(255,255,255,0.1)', marginRight: 6, marginBottom: 6 }}>{p}</span>)}
              </div>
            </div>
            {/* Collections */}
            <div>
              <h4 style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#c9a46a', marginBottom: 14 }}>Collections</h4>
              {[['/collections/silk-sarees','Silk Sarees'],['/collections/cotton-sarees','Cotton Sarees'],['/collections/wedding','Wedding Collection'],['/collections/jari-sarees','Zari / Jari Work'],['/collections/ikat','Ikat Collection'],['/collections/festival','Festival Special']].map(([to,l]) => <Link key={to} to={to} style={footLink}>{l}</Link>)}
            </div>
            {/* Account */}
            <div>
              <h4 style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#c9a46a', marginBottom: 14 }}>My Account</h4>
              {[['/login','Login / Register'],['/orders','Track Orders'],['/videos','Our Videos'],['/instagram','Instagram'],['/wishlist','Wishlist'],['/account','Profile']].map(([to,l]) => <Link key={to} to={to} style={footLink}>{l}</Link>)}
              <h4 style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#c9a46a', marginBottom: 14, marginTop: 20 }}>Help</h4>
              {[['#','Shipping Policy'],['#','Returns & Exchange'],['#','Care Instructions'],['#','FAQ']].map(([to,l]) => <a key={l} href={to} style={footLink}>{l}</a>)}
            </div>
            {/* Contact */}
            <div>
              <h4 style={{ fontSize: 10, letterSpacing: 3, textTransform: 'uppercase', color: '#c9a46a', marginBottom: 14 }}>Contact Us</h4>
              {['📍 Demo, Nellore Dist.\nAndhra Pradesh — 524132','📞 +91 90326 72270','✉️ hello@demoshop.in','⏰ Mon–Sat: 9AM–7PM IST'].map(line => (
                <div key={line} style={{ color: 'rgba(255,255,255,0.5)', fontSize: 12, marginBottom: 12, lineHeight: 1.7 }}>
                  {line.split('\n').map((l,i) => <span key={i} style={{ display: 'block' }}>{l}</span>)}
                </div>
              ))}
              {/* WhatsApp CTA */}
              <a href="https://wa.me/919032672270" target="_blank" rel="noopener noreferrer"
                style={{ display: 'inline-flex', alignItems: 'center', gap: 8, marginTop: 8, background: '#25D366', color: '#fff', padding: '9px 18px', fontSize: 12, fontWeight: 600, textDecoration: 'none' }}>
                💬 WhatsApp Us
              </a>
            </div>
          </div>
          {/* Bottom */}
          <div style={{ borderTop: '1px solid rgba(255,255,255,0.09)', padding: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
            <div style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11 }}>© 2026 Demo Shop. Crafted for preview showcase</div>
            <div style={{ display: 'flex', gap: 20 }}>
              {['Privacy Policy', 'Terms of Service', 'GI Certified'].map(l => <a key={l} href="#" style={{ color: 'rgba(255,255,255,0.3)', fontSize: 11, textDecoration: 'none' }}>{l}</a>)}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
